import { supabase } from "@/integrations/supabase/client";

const MAX_PER_REQUEST = 50;

/**
 * Gives CRM records that have no Customer Graph profile (contacts added by
 * hand with New customer) one, through contacts-import's "link" mode. Without
 * a profile they get no lifecycle status and Analytics can't count them.
 * Best-effort: returns the customer ids that were linked, [] on any failure.
 */
export async function linkCustomersToGraph(businessId: string, customerIds: string[]): Promise<string[]> {
  const ids = [...new Set(customerIds)].slice(0, MAX_PER_REQUEST);
  if (ids.length === 0) return [];
  try {
    const { data, error } = await supabase.functions.invoke("contacts-import", {
      body: { mode: "link", business_id: businessId, customer_ids: ids },
    });
    if (error) {
      console.warn("Customer profile link failed:", error.message);
      return [];
    }
    return Array.isArray(data?.linked)
      ? data.linked.map((row: { customer_id: string }) => row.customer_id)
      : [];
  } catch (error) {
    console.warn("Customer profile link failed:", error);
    return [];
  }
}
